import { default as checkoutPromotionCode } from './promotionCode';

export const promotionCode = {
  ...checkoutPromotionCode,
};
